import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import logo from "../images/logo.png"

import NavBar from './navigation';
import "../styles/header.css"


const Header = ({ siteTitle }) => (
    <header className="main-header-container">
        <div className="header">
            <Link
                to="/"
                className="nav-link name"
            >
                <img src={logo} alt="Logo" className="dave-logo" />
            </Link>
            <NavBar />
        </div>
    </header>
)

Header.propTypes = {
    siteTitle: PropTypes.string,
}

Header.defaultProps = {
    siteTitle: ``,
}

export default Header